import React, { useContext } from 'react'
import styled from 'styled-components'
import { AppContext } from '../../contexts/AppContext';

const Container = styled.div`
    margin: 0 10%;
`

const OrderedList = styled.ol`
    font-size: 12px;
`

export default function MobilityTableCaptions() {
    const { appState, sendEvent } = useContext(AppContext);

    return (
        <Container>
            <OrderedList>
                <li>{appState.i18n.tablesCaptions.costPerKWH}</li>
                <li>{appState.i18n.tablesCaptions.price}</li>
                <li>{appState.i18n.tablesCaptions.pvp}</li>
            </OrderedList>
        </Container>
    )
}
